module.exports = __webpack_public_path__ + "img/ic_arrow_right_secondary.b37d7e68.svg";